__turbopack_context__.v({
  "arrow": "ArrowLink-module-scss-module__zrtCeW__arrow",
  "large": "ArrowLink-module-scss-module__zrtCeW__large",
  "main": "ArrowLink-module-scss-module__zrtCeW__main",
  "medium": "ArrowLink-module-scss-module__zrtCeW__medium",
  "on-dark": "ArrowLink-module-scss-module__zrtCeW__on-dark",
  "on-light": "ArrowLink-module-scss-module__zrtCeW__on-light",
  "small": "ArrowLink-module-scss-module__zrtCeW__small",
});
